import { jsx } from 'react/jsx-runtime';
import NextImage from 'next/image';
import { getImageLoader } from './helpers/get-image-loader.esm.js';
import { shouldFillParentContainer } from './helpers/should-fill-parent-container.esm.js';
import { upgradeImageProtocol } from './helpers/upgrade-image-protocol.esm.js';

const getSvgPlaceholder = ({ width, height, placeholder })=>{
    if (typeof placeholder === 'string') {
        return placeholder;
    }
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width || '100%'}' height='${height || '100%'}' viewBox='0 0 ${width} ${height}'%3E%3Crect fill='%23F2F2F2' width='${width}' height='${height}'/%3E%3C/svg%3E`;
};
const Image = (props)=>{
    const { src, /**
     * Set this to true to load the image immediately
     *
     * @see https://nextjs.org/docs/pages/building-your-application/optimizing/images#priority
     */ priority = false, /**
     * Warning: This will disable the optimization of the image
     */ unoptimized = false, /**
     * This is a placeholder image that will be shown while the image is loading
     * or if the image fails to load. This is set to 'empty' by default to prevent
     * the Next.js Image component from showing a broken image icon.
     */ placeholder, /**
     * This is the quality of the image that will be loaded. This is set to 75 by
     * default to prevent the image from being too large.
     */ quality = 75, /**
     * Prevent passing the resize and fill prop to the NextImage component
     */ resize: _resize, fill: _fill, ...rest } = props;
    const imageWithUpgradedProtocol = typeof src === 'string' ? upgradeImageProtocol(src) : src;
    const loader = getImageLoader({
        ...props,
        src: imageWithUpgradedProtocol
    });
    const placeholderBlurDataURL = getSvgPlaceholder(props);
    return jsx(NextImage, {
        /**
         * Only set the fill property if the width and height are not explicitly set
         */ fill: shouldFillParentContainer(props),
        loader: loader,
        blurDataURL: placeholderBlurDataURL,
        placeholder: placeholder ? 'blur' : 'empty',
        priority: priority,
        quality: quality,
        src: imageWithUpgradedProtocol || placeholderBlurDataURL,
        unoptimized: unoptimized || !loader,
        ...rest
    });
};

export { Image };
